var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.21111C1 8.21111 4.66667 1 11.0833 1C17.5 1 21.1667 8.21111 21.1667 8.21111C21.1667 8.21111 17.5 15.4222 11.0833 15.4222C4.66667 15.4222 1 8.21111 1 8.21111Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 10.9153C12.6021 10.9153 13.8333 9.70458 13.8333 8.21111C13.8333 6.71764 12.6021 5.50694 11.0833 5.50694C9.56455 5.50694 8.33333 6.71764 8.33333 8.21111C8.33333 9.70458 9.56455 10.9153 11.0833 10.9153Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.e79bb73be850b0c1f0a5d7022f05c2d9.svg";
export { ForwardRef as ReactComponent };